import { Component, type ErrorInfo, type ReactNode } from 'react';
import { getLogger } from '../../../libs/logger';
import { toast } from '@doxyme/ui/components/foundations';
import { getFrontendConfigLoader } from '@doxyme/config';

const logger = getLogger('ExtensionsErrorBoundary');

type Props = {
  children: ReactNode;
};

type State = {
  error: Error | undefined;
};

export class ExtensionsErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { error: undefined };
  }

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    logger.error('Uncaught error:', error, errorInfo);
  }

  override render(): ReactNode | null {
    if (this.state.error) {
      if ((getFrontendConfigLoader().get('ENV') as string) !== 'production') {
        toast.error({
          title: this.state.error.message,
        });
      }
      return null;
    }

    return this.props.children;
  }
}
